import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

export default function ScoreBand ({arr = [], id, productBandInfo, maxScore, chapterValue, scoreType = '', hideScoreRange = false}) {
    const productBandObj = productBandInfo ? productBandInfo : arr?.filter(item => item.productAssociationId === id)[0];
    
    function scoreBandLabelHandler (arr, id, maxScore) {
        const bandArr = bandArrHandler(arr, id);
        
        const bandObj = bandArr?.find(item => item.benchmarkId === productBandObj?.finalBenchMarkId)
        let label='-'
        if(bandObj) {
            label=bandObj.benchmarkName
        }else {
            console.error('benchmark id -',productBandObj?.finalBenchMarkId ,' is missing in the product band array -' , bandArr)
        }
        return label;
    }

    function bandArrHandler (arr, id) {
        const bandArr = productBandObj?.bands;
        const scoreLabel = productBandObj?.scoreLabel || 'Score';
        if(!bandArr || !Array.isArray(bandArr)) {
            return [];
        }
        bandArr.sort((a,b) => a.threshold - b.threshold)

        if (hideScoreRange) {
            return bandArr;
        }

        for (let i = 0; i < bandArr.length; i++) {
            if(i === 0) {
                bandArr[i].scoreRange = `0 ≤ ${scoreLabel} < ${bandArr[i+1]?.threshold}`;
            } else if(i !== 0 && i < bandArr.length - 1) {
                bandArr[i].scoreRange = `${bandArr[i].threshold} ≤ ${scoreLabel} < ${bandArr[i+1].threshold}`;
            } else if(i !== 0 && i === bandArr.length - 1) {
                bandArr[i].scoreRange = `${bandArr[i].threshold} ≤ ${scoreLabel} < 100`;
            }
        }

        return bandArr;
    }

    function getScoreBandTooltip () {
        const bandArr = bandArrHandler(arr,id);
        
        const toolTipDom = bandArr?.map((item, index) => {
            return (
                <div key={index} className="band-tooltip-container">
                    {item.bandColor ? <span className="band-bullet" style={{backgroundColor: item.bandColor}}></span> : null}
                    {hideScoreRange ? (
                        <b>{item?.benchmarkName || '-'}</b>
                    ) : (
                        <React.Fragment><b>{item?.scoreRange}</b> {scoreType} : {item?.benchmarkName || '-'}</React.Fragment>
                    )}
                </div>
            );
        });
        return toolTipDom;
    }

    return (
        <OverlayTrigger
            placement='top'
            overlay={(props) => (
                <Tooltip id="band-tooltip" {...props}>
                    <div>
                        {getScoreBandTooltip()}
                    </div>
                </Tooltip>
            )}
        >
            <div className={chapterValue === "SummaryChapter" ? 'scoreBand-container-inline d-inline' : 'scoreBand-container'}>
                <span className='font-small-os'>{scoreBandLabelHandler(arr, id, maxScore)}</span>
            </div>
        </OverlayTrigger>
    );
}
